
import { Vue, Component } from "vue-property-decorator";
import lottie from "lottie-web"
import erroMarkJson from "../../assets/error.json"
import { GroupIdInput } from '@fubonlife/tacallindiy-core-axios-sdk';

@Component
export default class Error03 extends Vue {

	mounted() {
		this.renderErrorAnimation();
	}

	// 失敗動畫
	renderErrorAnimation() {
		const container = this.$refs.animationContainer as Element
		const options = {
			animationData: erroMarkJson,
			loop: false,
			autoplay: true
		}
		lottie.loadAnimation({
			container: container,
			renderer: 'svg',
			...options
		})
	}

	links = null;

	created() {
		const input: GroupIdInput = {
			groupId: 'CDIY_LINKS'
		}
		this.$CommonControllerApi.getStatusCodeUsingPOST1(input)
			.then(res => {
				if (res.status === 200) {
					this.links = JSON.parse(JSON.stringify(res.data))
				}
			})
			.catch(err => {
				console.log(err)
			})
	}

	// 服務人員：保戶會員專區Url
	findServiceUrl() {
		window.open(this.links['INSURED'], "_blank")
	}

	// 富邦人壽櫃檯：官網服務據點
	findCounterUrl() {
		window.open(this.links['SERVICE'], "_blank")
	}

	// 網路投保：網路投保首頁
	findOnlineInsureUrl() {
		window.open(this.links['ONLINE'], "_blank")
	}

}
